import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/week-detail-view/components/WeekDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/AppLayout.tsx");
